module.exports = __webpack_public_path__ + "static/media/42r.8991e5bd.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Deconstructed/42r.JPG
// module id = 338
// module chunks = 0